import { AppInjector } from './../../../app-injector';
import { Inventory } from './../invetory.reducer';
import { NotificationService } from './../../../common/services/notification/notification.service';
import { Destination } from './../../destination/destination.reducer';
import { ApiService } from './../../../api/api.service';
import { API_CALL_ERROR } from './../../../store/action';
import { call, put, takeEvery, takeLatest, fork, select } from 'redux-saga/effects';
import {
	FETCH_INVENTORY_REQUESTED,
	FETCH_INVENTORY_SUCCEEDED,
	FETCH_INVENTORY_LOCATION_REQUESTED,
	MAP_DESTINATION_TO_PRODUCT_LOCATION,
	FETCH_INVENTORY_DESTINATION_REQUESTED,
	UPDATE_INVENTORY_DESTINATION,
	UPDATE_INVENTORY_LOCATION_SUCCEEDED,
	BULK_UPDATE_INVENTORIES_LOCATION_REQUESTED,
	BULK_UPDATE_INVENTORIES_LOCATION_SUCCEEDED,
	SELECT_INVENTORY_REQUESTED,
	SELECT_INVENTORY,
	FETCH_BULK_INVENTORIES_REQUESTED,
	FETCH_BULK_INVENTORIES_SUCCEEDED,
	FILTER_INVENTORY_SUCCEEDED,
	FILTER_INVENTORY_REQUESTED,
	UPDATED_DESTINATION_LOCATIONS_REQUESTED,
	UPDATE_INVENTORY_FILTER,
	PRE_FILL_FILTER_FILTER,
	SEARCH_INVENTORY_REQUESTED,
	INVENTORY_SAVE_PRODUCT_LOCATION,
	INVENTORY_SAVE_PRODUCT_LOCATION_SUCCEEDED,
	NO_PRODUCT_LOCATION_FOUND,
	ADD_PENDING_PRODUCT,
	REMOVE_PENDING_PRODUCT,
	FETCH_PRODUCT_LOCATION_LAST_TRACK_SUCCEEDED
} from './list.action';
import * as _ from 'lodash';
import { ReflectiveInjector, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FETCH_ALL_DESTINATION_REQUESTED, FETCH_ALL_DESTINATION_SUCCEEDED } from '../../destination/destination.action';
import { PreloaderService } from '../../../common/services/preloader/preloader.service';
import { SAVE_PRODUCT_LOCATION_SUCCEEDED, UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED } from '../batch/batch.actions';

function* fetchInventories(action) {
	AppInjector.get(PreloaderService).show();
	const api = AppInjector.get(ApiService);
	try {
		let result = yield api.inventory.get(action.data).toPromise();
		yield put({
			type: FETCH_INVENTORY_SUCCEEDED,
			data: result.items,
			pagination: result.pagination
		});
		AppInjector.get(PreloaderService).hide();
	} catch (e) {
		AppInjector.get(PreloaderService).hide();
		yield put({ type: API_CALL_ERROR, error: e });
	}
}

function* watchFetchInventoryRequested() {
	yield takeEvery(FETCH_INVENTORY_REQUESTED, fetchInventories);
}

function* fetchDestinations(action) {
	yield put({ type: FETCH_ALL_DESTINATION_REQUESTED, com: 'PRODUCT_LOCATION_LIST' });
}

function* checkAllProductIsExisting(action) {
	let skus = AppInjector.get(ActivatedRoute).snapshot.queryParams.skus;
	let mltsa = AppInjector.get(ActivatedRoute).snapshot.queryParams.mltsa;
	if (!_.isUndefined(skus) && skus !== '' && (_.isUndefined(mltsa) || mltsa === 'product_sku')) {
		skus = skus.replace(/\s+/g, '').split(',');
		if (action.data.length === 0 || action.data.length < skus.length) {
			let found_product_locations = _.map(action.data, item => item.getProductSku());
			yield put({ type: NO_PRODUCT_LOCATION_FOUND, data: _.filter(skus, item => !_.includes(found_product_locations, item)) });
		}
	}
}

function* fetchLastTrackOfProducts(action) {
	try {
		let result = yield AppInjector.get(ApiService)
			.track.getLastTrackOfProducts({ product_ids: _.map(action.data, item => item.product_id).join(',') })
			.toPromise();
		yield put({
			type: FETCH_PRODUCT_LOCATION_LAST_TRACK_SUCCEEDED,
			data: result
		});
	} catch (e) {
		yield put({ type: API_CALL_ERROR, error: e });
	}
}

function* watchFetchInventorySUCCEEDED() {
	yield takeLatest(FETCH_INVENTORY_SUCCEEDED, fetchDestinations);
	yield takeLatest(FETCH_INVENTORY_SUCCEEDED, fetchLastTrackOfProducts);
	yield takeLatest(FETCH_INVENTORY_SUCCEEDED, checkAllProductIsExisting);
}

function* checkProductIsExisting(action) {
	try {
		let data = yield AppInjector.get(ApiService)
			.product.list({ skus: action.data })
			.toPromise();
		yield put({ type: ADD_PENDING_PRODUCT, data: data });
	} catch (error) {
		yield put({ type: 'PRODUCT_NOT_FOUND' });
	}
}

function* watchNoProductLocationFound() {
	yield takeLatest(NO_PRODUCT_LOCATION_FOUND, checkProductIsExisting);
}

function* assignProductLocationWithDestination(action) {
	if (action.com === 'PRODUCT_LOCATION_LIST') {
		yield put({ type: MAP_DESTINATION_TO_PRODUCT_LOCATION, data: action.data });
	}
}

function* watchFetchAllDestinationSUCCEEDED() {
	yield takeEvery(FETCH_ALL_DESTINATION_SUCCEEDED, assignProductLocationWithDestination);
}

function* bulkUpdateInventoriesLocation(action) {
	const notify = AppInjector.get(NotificationService);
	const api = AppInjector.get(ApiService);

	try {
		let result = yield api.event.bulk(action.data).toPromise();
		yield put({
			type: BULK_UPDATE_INVENTORIES_LOCATION_SUCCEEDED,
			data: result
		});
		notify.show('success', 'Inventories are updated', 3000);
	} catch (e) {
		yield put({ type: API_CALL_ERROR, error: e });
	}
}

function* watchBulkUpdateInventoriesLocation() {
	yield takeEvery(BULK_UPDATE_INVENTORIES_LOCATION_REQUESTED, bulkUpdateInventoriesLocation);
}

function* filterInventories(action) {
	const api = AppInjector.get(ApiService);
	try {
		let results = yield api.inventory.filter(action.data).toPromise();
		yield put({ type: FETCH_INVENTORY_SUCCEEDED, data: results.items });
	} catch (e) {
		yield put({ type: API_CALL_ERROR, error: e });
	}
}

function* watchFilterInventoriesRequest() {
	yield takeEvery(FILTER_INVENTORY_REQUESTED, filterInventories);
}

function updateInventoryRouter(action) {
	let activeRouter = AppInjector.get(ActivatedRoute);
	let router = AppInjector.get(Router);
	let params = activeRouter.snapshot.params;
	let queryParams = _.assign({}, activeRouter.snapshot.queryParams, { page: 1 });
	let url = activeRouter.snapshot.url;
	let constraints = {};
	if (!_.isUndefined(queryParams.constraints)) {
		constraints = _.assign(constraints, JSON.parse(queryParams.constraints));
	}
	if (action.field === 'destination') {
		if (!_.isUndefined(action.data)) {
			constraints = _.assign(constraints, { destination_id: action.data.getId() });
		} else {
			delete constraints['destination_id'];
		}
	}
	if (action.field === 'location') {
    if (!_.isUndefined(action.data)) {
      constraints = _.assign(constraints, { location_id: action.data.getId() });
    } else {
      delete constraints['location_id'];
    }
  }
  if (action.field === 'process_status') {
    if (!_.isUndefined(action.data)) {
      constraints = _.assign(constraints, { process_statuses: action.data.join(',') });
    } else {
      delete constraints['location_id'];
    }
  }
	queryParams = _.assign(queryParams, { constraints: JSON.stringify(constraints) });
	router.navigate([url], { queryParams: queryParams });
}

function* watchUpdateInventoryFilter() {
	yield takeEvery(UPDATE_INVENTORY_FILTER, updateInventoryRouter);
}

function* searchInventory(action) {
	const api = AppInjector.get(ApiService);
	try {
		let results = yield api.inventory.search(action.data).toPromise();
		yield put({ type: FETCH_INVENTORY_SUCCEEDED, data: results.items, total: results.total });
	} catch (e) {
		yield put({ type: API_CALL_ERROR, error: e });
	}
}

function* watchSearchInventoryRequest() {
	yield takeEvery(SEARCH_INVENTORY_REQUESTED, searchInventory);
}

function* saveProductLocationSUCCEEDED(action) {
	if (action.com === 'INVENTORY_PENDING_PRODUCT_PAGE') {
		yield put({ type: REMOVE_PENDING_PRODUCT, data: [action.product_id] });
		let query = yield select(state => (state as any).Inventory.list.query);
		yield put({ type: FETCH_INVENTORY_REQUESTED, data: query });
	}
	if (action.com === 'INVENTORY_PRODUCT_PAGE') {
		AppInjector.get(NotificationService).show('success', 'Product location is updated', 3000);
	}
	if (action.type === UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED && action.com === 'INVENTORY_PRODUCT') {
		yield put({ type: REMOVE_PENDING_PRODUCT, data: _.map(action.data, item => item.getProductId()) });
		let query = yield select(state => (state as any).Inventory.list.query);
		yield put({ type: FETCH_INVENTORY_REQUESTED, data: query });
	}
}

function* watchSaveProductLocation() {
	yield takeLatest(SAVE_PRODUCT_LOCATION_SUCCEEDED, saveProductLocationSUCCEEDED);
	yield takeLatest(UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED, saveProductLocationSUCCEEDED);
}

export default [
	watchFetchInventoryRequested,
	watchFetchInventorySUCCEEDED,
	watchNoProductLocationFound,
	watchFetchAllDestinationSUCCEEDED,
	watchBulkUpdateInventoriesLocation,
	watchFilterInventoriesRequest,
	watchUpdateInventoryFilter,
	watchSearchInventoryRequest,
	watchSaveProductLocation
];
